const DEFAULT_BACKGROUND = 'transparent'

// Calculated as size of layer tool preview box minus 2
const WIDGET_PREVIEW_SIZE = 28

export {
  DEFAULT_BACKGROUND,
  WIDGET_PREVIEW_SIZE,
}
